const YOUTUBE_REGEX =
  /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/|watch\?.*v=))([^#&?]{11}).*/;

export function extractYouTubeId(url) {
  if (!url || typeof url !== "string") return null;
  const match = url.trim().match(YOUTUBE_REGEX);
  return match && match[1].length === 11 ? match[1] : null;
}

export function isYouTubeUrl(url) {
  return extractYouTubeId(url) !== null;
}

/**
 * Trả về embed URL nếu là YouTube hợp lệ, null nếu không phải.
 * Component modal sẽ dùng null để fallback sang window.open().
 */
export function getYouTubeEmbedUrl(url) {
  const id = extractYouTubeId(url);
  return id ? `https://www.youtube.com/embed/${id}` : null;
}
